import { FiAlertCircle, FiCheck, FiX } from "react-icons/fi";

export default function TagDraftPreview({ names, duplicates, tooLong, disabled, onRemove }) {
	if (!names.length) return null;
	const valid = names.length - duplicates.length - tooLong.length;
	return <section className="tag-draft-preview" aria-label="Tag preview">
		<div className="tag-draft-heading"><h2>Ready to add</h2><span>{valid} new {valid === 1 ? "tag" : "tags"}</span></div>
		<ul>{names.map((name) => {
			const duplicate = duplicates.includes(name), invalid = tooLong.includes(name);
			return <li key={name} className={invalid ? "is-invalid" : duplicate ? "is-duplicate" : ""}>
				<span aria-hidden="true">{invalid || duplicate ? <FiAlertCircle /> : <FiCheck />}</span>
				<div><strong>{name}</strong><span>{invalid ? "Over 60 characters — shorten this name" : duplicate ? "Already exists — will be skipped" : "New tag"}</span></div>
				<button type="button" disabled={disabled} onClick={() => onRemove(name)} aria-label={`Remove ${name}`}><FiX aria-hidden="true" /></button>
			</li>;
		})}</ul>
	</section>;
}
